import { FirestoreDataConverter } from "@angular/fire/firestore";
import { FormControl, FormGroup } from "@angular/forms";

export type ScriptErrorForm = FormGroup<{
  id: FormControl<string>;
  code: FormControl<string>;
  description: FormControl<string>;
  organizationId: FormControl<string>;
}>

export class ScriptError {
  id: string;
  code: string;
  description: string;
  organizationId: string;

  constructor(scriptError?: Partial<ScriptError>) {
    this.id = scriptError?.id ?? '';
    this.organizationId = scriptError?.organizationId ?? '';
    this.code = scriptError?.code ?? '';
    this.description = scriptError?.description ?? '';
  }

  /**
   * Converter used to convert an object from firebase
   */
  static converter: FirestoreDataConverter<ScriptError> = {
    toFirestore: (scriptError: ScriptError) => ({
      id: scriptError.id,
      organizationId: scriptError.organizationId,
      code: scriptError.code,
      description: scriptError.description,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new ScriptError({ ...data, id: snapshot.id });
    }
  };
}
